import { FormikProps } from "formik";
import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

export const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

export const normalizeHexColor = (
    value: string | null | undefined,
    fallback: string
): string => (HEX_COLOR_REGEX.test(value ?? "") ? (value as string).toUpperCase() : fallback);

interface HexColorSelectorProps {
    formikProps: FormikProps<any>;
    name: string;
    label: string;
    fallbackColor: string;
    allowNull?: boolean;
}

export const HexColorSelector = (props: HexColorSelectorProps) => {
    const rawValue = props.formikProps.values[props.name] as string | null | undefined;
    const hasNoColor = (props.allowNull ?? false) && !rawValue;
    const colorValue = normalizeHexColor(rawValue, props.fallbackColor);

    return (
        <FormGroup style={{ minWidth: 170 }}>
            <Label>{props.label}</Label>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Input
                    type="color"
                    value={colorValue}
                    disabled={hasNoColor}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        props.formikProps.setFieldValue(props.name, e.target.value.toUpperCase())
                    }
                    style={{ width: 44, height: 38, padding: 4 }}
                />
                <Input
                    type="text"
                    value={rawValue ?? ""}
                    placeholder="#RRGGBB"
                    disabled={hasNoColor}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        props.formikProps.setFieldValue(props.name, e.target.value.toUpperCase())
                    }
                    style={{ width: 108 }}
                />
            </div>
            {props.allowNull && (
                <FormGroup check className="mt-1">
                    <Label check>
                        <Input
                            type="checkbox"
                            checked={hasNoColor}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                props.formikProps.setFieldValue(
                                    props.name,
                                    e.target.checked ? null : props.fallbackColor
                                )
                            }
                        />
                        None
                    </Label>
                </FormGroup>
            )}
        </FormGroup>
    );
};
